import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Input, Form, Button, FormText, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import moment from "moment";

import ResetPasswordModal from "./ResetPasswordModal";
import alertConstants from "../../constants/alertConstants";
import userActions from "../../actions/userActions";

const Litigants = () => {
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alert);
  const [submittedStep, setSubmittedStep] = useState("0");
  const [submittedStepRegister, setSubmittedStepRegister] = useState("0");
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const {
    register: registerRegister,
    errors: errorsRegister,
    handleSubmit: handleSubmitRegister,
    watch,
  } = useForm({
    mode: "onChange",
  });
  const passwordWatch = watch("password", "");

  const onSubmit = (data) => {
    if (data.username && data.password) {
      setSubmittedStep("1");
      dispatch(userActions.login(data.username, data.password));
    }
  };

  const onSubmitRegister = (data) => {
    setSubmittedStepRegister("1");
    const registerUser = {
      ...data,
      dob: moment(data.dob).toISOString(),
    };
    dispatch(
      userActions.register(
        registerUser.dob,
        registerUser.firstName,
        registerUser.lastName,
        registerUser.email,
        registerUser.password,
        registerUser.confirmPassword,
        registerUser.phoneNumber
      )
    );
  };

  useEffect(() => {
    dispatch(userActions.logout());
  }, [dispatch]);

  useEffect(() => {
    //console.log(alert);
    if (alert.type === alertConstants.ERROR) {
      setSubmittedStepRegister("0");
      setSubmittedStep("0");
    }
  }, [alert]);
  return (
    <Row className="psInfo">
      <Col>
        <h2 className="text-center text-uppercase">Litigants</h2>
        <hr />
        <Row>
          <Col className="d-flex justify-content-center">
            <p>
              Are you seeking assistance as a Plaintiff (a person who brings a
              case against another in a court of law) or a Defendant (an
              individual, company, or institution sued or accused in a court of
              law)?
            </p>
          </Col>
        </Row>
        <Row className="psInfo">
          <Col xl={6}>
            <h4>Sign in</h4>
            <p>
              Need to change an upcoming appointment, update your questionnaire
              or schedule a new appointment? Log in here.
            </p>
          </Col>
          <Col xl={6}>
            <h4>Register</h4>
            <p>
              Register below to begin scheduling an appointment.{" "}
              <i>
                All fields below are required. Passwords must be at least six
                characters long, contain an uppercase character, lowercase
                character, a digit, and a non-alphanumeric character.
              </i>
            </p>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            {/* Login */}
            <Form key={1} onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col>
                  <Input
                    type="email"
                    name="username"
                    innerRef={register({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address.",
                      },
                    })}
                    placeholder="E-mail"
                    autoComplete="off"
                    className={errors?.username ? "custError" : ""}
                  />
                  <FormText>
                    Enter your email.{" "}
                    <i style={{ color: "red" }}>
                      {errors.username && errors.username.message}
                    </i>
                    {errors?.username?.type === "required" && (
                      <i style={{ color: "red" }}> Email required.</i>
                    )}
                    {errors?.username?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col>
                  <Input
                    type="password"
                    name="password"
                    innerRef={register({
                      required: true,
                      minLength: 6,
                    })}
                    placeholder="Password"
                    autoComplete="off"
                    className={errors?.password ? "custError" : ""}
                  />
                  <FormText>
                    Enter your password.
                    {errors?.password?.type === "required" && (
                      <i style={{ color: "red" }}> Password required.</i>
                    )}
                    {}
                    {errors?.password?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col>
                  <div className={submittedStep === "1" ? "d-block" : "d-none"}>
                    <Spinner color="dark" />
                  </div>
                  <div className={submittedStep === "2" ? "d-block" : "d-none"}>
                    <p>Thank you, your request has been submitted.</p>
                  </div>
                  <Button
                    type="submit"
                    className={
                      submittedStep === "0" ? "blueButton d-block" : "d-none"
                    }
                    style={{ width: "100%", height: "100%" }}
                  >
                    Login
                  </Button>
                  <ResetPasswordModal buttonLabel="Forgot Password?" />
                </Col>
              </Row>
            </Form>
          </Col>
          <Col xl={6}>
            {/* Register */}
            <Form key={2} onSubmit={handleSubmitRegister(onSubmitRegister)}>
              <Row>
                <Col md={6}>
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="First name"
                    className={errorsRegister?.firstName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your first name.{" "}
                    {errorsRegister?.firstName?.type === "required" && (
                      <i style={{ color: "red" }}> First name is required.</i>
                    )}
                    {errorsRegister?.firstName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col md={6}>
                  <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="Last name"
                    className={errorsRegister?.lastName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your last name.{" "}
                    {errorsRegister?.lastName?.type === "required" && (
                      <i style={{ color: "red" }}> Last name is required.</i>
                    )}
                    {errorsRegister?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col md={6}>
                  <Input
                    type="text"
                    name="dob"
                    id="dob"
                    innerRef={registerRegister({
                      required: true,
                      pattern: {
                        value: /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/,
                        //value: /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/,
                        message: "Please enter a valid date MM/DD/YYYY.",
                      },
                    })}
                    placeholder="MM/DD/YYYY"
                    className={errorsRegister?.dob ? "custError" : ""}
                  />
                  <FormText>
                    Enter your DOB.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.dob && errorsRegister.dob.message}
                    </i>
                    {errorsRegister?.dob?.type === "required" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Date of birth is required.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col md={6}>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="E-mail"
                    innerRef={registerRegister({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address.",
                      },
                    })}
                    className={errorsRegister?.email ? "custError" : ""}
                    autoComplete="off"
                  />
                  <FormText>
                    Enter your email.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.email && errorsRegister.email.message}
                    </i>
                    {errorsRegister?.email?.type === "required" && (
                      <i style={{ color: "red" }}> Email is required.</i>
                    )}
                    {errorsRegister?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col md={12}>
                  <Input
                    type="text"
                    name="phoneNumber"
                    id="phoneNumber"
                    innerRef={registerRegister({
                      required: true,
                      pattern: {
                        value: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                        message: "Enter a valid phone number",
                      },
                    })}
                    placeholder="Phone number ###-###-####"
                    className={errorsRegister?.phoneNumber ? "custError" : ""}
                    autoComplete="off "
                  />
                  <FormText>
                    Enter a phone number.
                    <i style={{ color: "red" }}>
                      {errorsRegister.phoneNumber &&
                        errorsRegister.phoneNumber.message}
                    </i>
                    {errorsRegister?.phoneNumber?.type === "required" && (
                      <i style={{ color: "red" }}> Phone number is required.</i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col md={6}>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    innerRef={registerRegister({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    placeholder="Password"
                    className={errorsRegister?.password ? "custError" : ""}
                  />
                  <FormText>
                    Enter your password.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.confirmPassword &&
                        errorsRegister.confirmPassword.message}
                    </i>
                    {errorsRegister?.password?.type === "pattern" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Password does not meet the requirements.
                      </i>
                    )}
                    <i style={{ color: "red" }}>
                      {errorsRegister.password &&
                        errorsRegister.password.message}
                    </i>
                    {errorsRegister?.password?.type === "required" && (
                      <i style={{ color: "red" }}> Password is required.</i>
                    )}
                    {errorsRegister?.password?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
                <Col md={6}>
                  <Input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    innerRef={registerRegister({
                      required: true,
                      validate: (value) =>
                        value === passwordWatch ||
                        "The passwords do not match.",
                    })}
                    placeholder="Confirm password"
                    className={
                      errorsRegister?.confirmPassword ? "custError" : ""
                    }
                  />
                  <FormText>
                    Confirm your password.{" "}
                    <i style={{ color: "red" }}>
                      {errorsRegister.confirmPassword &&
                        errorsRegister.confirmPassword.message}
                    </i>
                    {errorsRegister?.confirmPassword?.type === "required" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Confirmation password is required
                      </i>
                    )}
                    {errorsRegister?.confirmPassword?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </Col>
              </Row>
              <Row className="padTop">
                <Col>
                  <div
                    className={
                      submittedStepRegister === "1" ? "d-block" : "d-none"
                    }
                  >
                    <Spinner color="dark" />
                  </div>
                  <div
                    className={
                      submittedStepRegister === "2" ? "d-block" : "d-none"
                    }
                  >
                    <p>Thank you, your request has been submitted.</p>
                  </div>
                  <Button
                    type="submit"
                    className={
                      submittedStepRegister === "0"
                        ? "blueButton d-block"
                        : "d-none"
                    }
                    style={{ width: "100%", height: "100%" }}
                  >
                    Register
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Litigants;
